// comparison of wind speen in directions
import React, { Component, useState } from 'react'
import Chart from "react-apexcharts";
// import { Pricing } from './pages';



function App(){
  // pm1 vs timesnap 
	const [state , setState] = useState( {
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: ["21/03/31,08:02:42", "21/03/23,07:28:02", "21/04/23,06:21:42", "21/03/22,05:58:43", "21/03/25,09:19:41", "21/04/20,17:22:40", "21/04/29,13:36:53", "21/03/22,09:40:16", "21/03/26,05:27:57" ]
    }
    },
    series: [
      {
        // first series initialization
        name: "series PM-1",
        data: [30,32,31,29,30,30,26,36,31,30,31,30,29,27,27,25,26,26,26,25,28,26,30,30,31,26,26,24,25,25,24,25,30,72,41,32,34,27,30,25,31,30,27,75,46,61,28,29,45,39,34,36,32,34,32,34,33,31,35,41,54,44,45,46,43,44,39,43,54,54,74,54,63,43,49,44,46,48,60,61,53,55,57,51,65,79,83,71,82,87,70,63,64,58,64,59,59,71,80]    
        },
        {
        // second series initialization
        name: "series PM-25",
        data: [48,32,31,29,30,30,26,36,31,30,31,30,29,27,27,25,26,26,26,25,28,26,30,30,31,26,26,24,25,25,24,25,30,72,41,32,34,27,30,25,31,30,27,75,46,61,28,29,45,39,34,36,32,34,32,34,33,31,35,41,54,44,45,46,43,44,39,43,54,54,74,54,63,43,49,44,46,48,60,61,53,55,57,51,65,79,83,71,82,87,70,63,64,58,64,59,59,71,80
        ]    
        },
        {
        // third series initialization
        name: "series PM-10",
        data: [62,67,64,62,61,62,54,54,60,58,68,66,63,52,54,58,55,57,54,52,70,54,59,70,70,54,55,52,53,45,53,61,53,99,67,67,62,58,63,48,62,56,62,108,72,82,57,58,75,76,66,76,66,74,71,74,71,62,94,77,107,84,77,98,86,97,77,81,87,90,115,84,103,76,100,94,99,83,98,118,100,102,119,106,133,132,164,139,157,184,136,137,154,117,170,115,124,140,168]    
        },
    
    ]
    
  })
// initializing app 
	return (
		<div className="my-app">
			<h1> Position of particles in first 100 cases </h1>
			<div className="row">
        <div className="col-4">
        <Chart
            options={state.options}
            series={state.series}
            type="bar"
             width="1000"
           />
        </div>
			</div>
		</div>
		);

	}

  export default App;